module.exports = __webpack_public_path__ + "static/media/IMG_1778-min.820ebea3.JPG";